export default function Avatar({ src, name, size = 40, className = "", testId }) {
  const style = { width: size, height: size, fontSize: size * 0.42 };
  if (src) {
    return <img data-testid={testId} src={src} alt={name || "avatar"} style={style}
      className={`rounded-full object-cover border border-pb-border shrink-0 ${className}`} />;
  }
  return (
    <div data-testid={testId} style={style}
      className={`rounded-full bg-pb-elevated border border-pb-border flex items-center justify-center font-display font-black text-pb-red shrink-0 ${className}`}>
      {(name || "?")[0]?.toUpperCase()}
    </div>
  );
}
